import { ICreateUserRequest, IUpdateMeRequest, IUpdateUserRequest } from '../../interfaces/user.interface';

export namespace UserActions {
  export class GetMe {
    static readonly type = '[User] Get Me';
  }

  export class SetMe {
    static readonly type = '[User] Set Me';
    constructor(public user: any) {}
  }

  export class UpdateMe {
    static readonly type = '[User] Update Me';
    constructor(public data: IUpdateMeRequest) {}
  }

  export class UpdateUser {
    static readonly type = '[User] Update User';
    constructor(public id: number, public data: IUpdateUserRequest) {}
  }

  export class CreateUser {
    static readonly type = '[User] Create User';
    constructor(public data: ICreateUserRequest) {}
  }

  export class GetUsers {
    static readonly type = '[User] Get Users';
    constructor(public page?: number, public pageSize?: number, public q?: string) {}
  }

  export class GetUserById {
    static readonly type = '[User] Get User By Id';
    constructor(public id: number) {}
  }

  export class ClearEditingUser {
    static readonly type = '[User] Clear Editing User';
  }

  export class DeleteUser {
    static readonly type = '[User] Delete User';
    constructor(public id: number) {}
  }

  export class UploadFile {
    static readonly type = '[User] Upload File';
    constructor(public userId: number, public file: File) {}
  }

  export class UploadFileSuccess {
    static readonly type = '[User] Upload File Success';
    constructor(public response: any) {}
  }

  export class UploadFileFailure {
    static readonly type = '[User] Upload File Failure';
    constructor(public error: any) {}
  }


  export class GetDeletedUsers {
    static readonly type = '[User] Get Deleted Users';
  }

  export class RestoreDeletedUser {
    static readonly type = '[User] Restore Deleted User';
    constructor(public id: number) {}
  }

}


